import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ControllerType } from '@bridgewerk/shared';
import { getApiClient } from '../../../lib/api-client.js';
import { machineKeys } from '../../../lib/query-keys.js';

export function useCreateMachine(shopId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ machineId, controllerType }: { machineId: string; controllerType: ControllerType }) =>
      getApiClient().createMachine(shopId!, machineId, controllerType),
    onSuccess: () => {
      if (shopId) void qc.invalidateQueries({ queryKey: machineKeys.list(shopId) });
    },
  });
}

export function useDeleteMachine(shopId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (machineId: string) =>
      getApiClient().deleteMachine(shopId!, machineId),
    onSuccess: () => {
      if (shopId) void qc.invalidateQueries({ queryKey: machineKeys.list(shopId) });
    },
  });
}
